import { Sha256 } from '@aws-crypto/sha256-js';
import { toHex } from '@aws-sdk/util-hex-encoding';

export function toSHA256({ str }: { str: string }) {
    const sha256Instance = new Sha256();

    sha256Instance.update(str);

    return toHex(sha256Instance.digestSync());
}
